(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9517],{

/***/ 31147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.756.512 22.244 0l-15 15 15 15 .512-.512L8.268 15z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgAngleLeft);

/***/ }),

/***/ 37863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgPeak = function SvgPeak(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0D5284",
    d: "M6.687 22.588c.224 0 .406.18.406.404v8.605a.405.405 0 0 1-.406.403H.407A.405.405 0 0 1 0 31.597v-8.605c0-.223.182-.404.406-.404Zm24.907-5.378c.224 0 .406.18.406.403v13.984a.405.405 0 0 1-.406.403h-6.281a.405.405 0 0 1-.406-.403V17.613c0-.222.182-.403.406-.403ZM6.28 23.395H.812v7.798h5.469v-7.798Zm24.907-5.378h-5.469v13.176h5.469z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FF6D5E",
    d: "m6.602 10.531-.036.045a.403.403 0 0 0 .338.628h5.874v20.393c0 .222.182.403.406.403h6.281l.055-.004a.404.404 0 0 0 .351-.4V11.205h5.875a.403.403 0 0 0 .302-.673L16.627.134a.41.41 0 0 0-.604 0L6.602 10.53Zm9.723-9.525 8.509 9.392h-5.369l-.055.003a.404.404 0 0 0-.35.4l-.001 20.392H13.59V10.801l-.003-.055a.405.405 0 0 0-.403-.348H7.815z"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgPeak);

/***/ }),

/***/ 17477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ Author; }
/* harmony export */ });
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41289);
/* harmony import */ var _Author_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43926);
/* harmony import */ var _Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Author_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var sizes = {
  md: 60,
  lg: 90,
  xl: 120
};
var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default().bind((_Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var Author = function Author(_ref) {
  var name = _ref.name,
      photo = _ref.photo,
      company = _ref.company,
      role = _ref.role,
      className = _ref.className,
      size = _ref.size,
      theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'dark' : _ref$color;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: cx('wrapper', color, className, theme),
    children: [photo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: cx('imageWrapper', size),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Image_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, {
        alt: name,
        className: (_Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default().avatar),
        height: sizes[size],
        src: photo,
        width: sizes[size]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("strong", {
        className: (_Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default().name),
        children: name
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
        className: (_Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default().company),
        children: [role, role && company && ' @ ', company]
      })]
    })]
  });
};

/***/ }),

/***/ 37078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Icon_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36905);
/* harmony import */ var _Icon_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Icon_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default().bind((_Icon_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
var Icon = function Icon(_ref) {
  var size = _ref.size,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 100 : _ref$opacity,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
    className: cx('icon', className, "opacity-".concat(opacity), "color-".concat(color)),
    style: {
      height: size,
      width: size
    },
    children: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(children, {
      width: size,
      height: size
    })
  });
};

/***/ }),

/***/ 91546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ LogosRow; }
/* harmony export */ });
/* unused harmony export mainLogos */
/* harmony import */ var _builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_Logo_Logo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42635);
/* harmony import */ var _components_Text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40426);
/* harmony import */ var _LogosRow_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8216);
/* harmony import */ var _LogosRow_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_LogosRow_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _logos_Black_esl_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76644);
/* harmony import */ var _logos_Colored_avast_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95145);
/* harmony import */ var _logos_Colored_banijay_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64533);
/* harmony import */ var _logos_Colored_rakuten_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24682);
/* harmony import */ var _logos_Colored_starz_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48550);
/* harmony import */ var _logos_Colored_udemy_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29847);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var mainLogos = [{
  src: _logos_Colored_starz_svg__WEBPACK_IMPORTED_MODULE_9__,
  name: 'Starz',
  width: 85,
  height: 25
}, {
  src: _logos_Colored_rakuten_svg__WEBPACK_IMPORTED_MODULE_8__,
  name: 'Rakuten',
  width: 85,
  height: 27
}, {
  src: _logos_Colored_udemy_svg__WEBPACK_IMPORTED_MODULE_10__,
  name: 'Udemy',
  width: 78,
  height: 29
}, {
  src: _logos_Black_esl_svg__WEBPACK_IMPORTED_MODULE_5__,
  name: 'ESL',
  width: 67,
  height: 21
}, {
  src: _logos_Colored_avast_svg__WEBPACK_IMPORTED_MODULE_6__,
  name: 'Avast',
  width: 88,
  height: 28
}, {
  src: _logos_Colored_banijay_svg__WEBPACK_IMPORTED_MODULE_7__,
  name: 'Banijay',
  width: 84,
  height: 24
}];
var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_LogosRow_module_scss__WEBPACK_IMPORTED_MODULE_12___default()));
var LogosRow = function LogosRow(_ref) {
  var _ref$logos = _ref.logos,
      logos = _ref$logos === void 0 ? mainLogos : _ref$logos,
      note = _ref.note;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("ul", {
    className: cx('wrapper', "count-".concat(logos.length)),
    children: [note && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
      className: (_LogosRow_module_scss__WEBPACK_IMPORTED_MODULE_12___default().noteWrapper),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_Text_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
        className: (_LogosRow_module_scss__WEBPACK_IMPORTED_MODULE_12___default().note),
        opacity: 80,
        size: 12,
        tag: "strong",
        transform: "uppercase",
        weight: "medium",
        children: note
      })
    }), logos.map(function (logo, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
        className: cx('logoWrapper', {
          withNote: note
        }),
        style: {
          animationDelay: "".concat(index * 50, "ms")
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_Logo_Logo__WEBPACK_IMPORTED_MODULE_3__/* .Logo */ .T, _objectSpread({}, logo))
      }, logo.name);
    })]
  });
};

/***/ }),

/***/ 34687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Paragraph_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97058);
/* harmony import */ var _Paragraph_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Paragraph_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default().bind((_Paragraph_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
var Paragraph = function Paragraph(_ref) {
  var _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'p' : _ref$tag,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 100 : _ref$opacity,
      maxWidth = _ref.maxWidth,
      className = _ref.className,
      isCentered = _ref.isCentered,
      dangerouslySetInnerHTML = _ref.dangerouslySetInnerHTML,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Tag // eslint-disable-next-line react/no-danger
  , {
    className: cx('paragraph', align, color, size, "opacity-".concat(opacity), className, {
      isCentered: isCentered
    }),
    dangerouslySetInnerHTML: dangerouslySetInnerHTML,
    style: {
      maxWidth: maxWidth
    },
    children: children
  });
};

/***/ }),

/***/ 23514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ ReviewsCarousel; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ReviewsCarousel/reviewsData.tsx + 1 modules
var reviewsData = __webpack_require__(72966);
// EXTERNAL MODULE: ./src/components/Author/Author.tsx
var Author = __webpack_require__(17477);
// EXTERNAL MODULE: ./src/components/Logo/Logo.tsx
var Logo = __webpack_require__(42635);
// EXTERNAL MODULE: ./src/components/Paragraph/Paragraph.tsx
var Paragraph = __webpack_require__(34687);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./src/components/Slider/Slider.module.scss
var Slider_module = __webpack_require__(92830);
var Slider_module_default = /*#__PURE__*/__webpack_require__.n(Slider_module);
// EXTERNAL MODULE: ./src/components/Images/Icons/angleLeft.svg
var angleLeft = __webpack_require__(31147);
// EXTERNAL MODULE: ./src/components/Images/Icons/angleRight.svg
var angleRight = __webpack_require__(69294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Slider/Slider.tsx



var _excluded = ["arrows", "dots"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var cx = bind_default().bind((Slider_module_default()));
var Slider = function Slider(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      settings = _ref.settings,
      dotLabels = _ref.dotLabels,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme,
      withShadow = _ref.withShadow,
      children = _ref.children;
  var sliderRef = react.useRef(null);

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeIndex = _React$useState2[0],
      setActiveIndex = _React$useState2[1];

  var arrows = settings.arrows,
      dots = settings.dots,
      otherSettings = (0,objectWithoutProperties/* default */.Z)(settings, _excluded);

  react.useEffect(function () {
    if ('autoplay' in otherSettings) {
      if (otherSettings.autoplay) {
        sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current.slickPlay();
      } else {
        sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current.slickPause();
      }
    }
  }, [otherSettings === null || otherSettings === void 0 ? void 0 : otherSettings.autoplay]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: cx('wrapper', variant, {
      withShadow: withShadow
    }),
    children: [dots && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: cx('list', theme),
      children: react.Children.map(children, function (_, index) {
        var _dotLabels$index;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: cx('item', {
            isActive: index === activeIndex
          }),
          children: [(dotLabels === null || dotLabels === void 0 ? void 0 : dotLabels[index]) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (Slider_module_default()).label,
            children: dotLabels[index]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            "aria-label": (_dotLabels$index = dotLabels === null || dotLabels === void 0 ? void 0 : dotLabels[index]) !== null && _dotLabels$index !== void 0 ? _dotLabels$index : "go to ".concat(index + 1, ". slide"),
            className: (Slider_module_default()).dotWrapper,
            type: "button",
            onClick: function onClick() {
              sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current.slickGoTo(index);
              setActiveIndex(index);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (Slider_module_default()).dot
            })
          })]
        });
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Slider_module_default()).sliderWrapper,
      children: [arrows && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          "aria-label": "prev slide",
          className: cx('arrow', 'prev'),
          disabled: !(otherSettings !== null && otherSettings !== void 0 && otherSettings.infinite) && activeIndex === 0,
          type: "button",
          onClick: function onClick() {
            sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current.slickPrev();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(angleLeft/* default */.Z, {
            className: (Slider_module_default()).icon
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          "aria-label": "next slide",
          className: cx('arrow', 'next'),
          disabled: !(otherSettings !== null && otherSettings !== void 0 && otherSettings.infinite) && activeIndex === children.length - 1,
          type: "button",
          onClick: function onClick() {
            sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current.slickNext();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(angleRight/* default */.Z, {
            className: (Slider_module_default()).icon
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: cx('slider', {
          withArrows: arrows
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread(_objectSpread({
          ref: sliderRef,
          beforeChange: function beforeChange(_, nextSlide) {
            return setActiveIndex(nextSlide);
          }
        }, otherSettings), {}, {
          arrows: false,
          dots: false,
          children: children
        }))
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/components/ReviewsCarousel/ReviewsCarousel.module.scss
var ReviewsCarousel_module = __webpack_require__(6035);
var ReviewsCarousel_module_default = /*#__PURE__*/__webpack_require__.n(ReviewsCarousel_module);
;// CONCATENATED MODULE: ./src/components/ReviewsCarousel/ReviewsCarousel.tsx


function ReviewsCarousel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ReviewsCarousel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ReviewsCarousel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ReviewsCarousel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var ReviewsCarousel_cx = bind_default().bind((ReviewsCarousel_module_default()));
var ReviewsCarousel = function ReviewsCarousel(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [reviewsData/* reviewStarz */.hw, reviewsData/* reviewRakuten */.kX, reviewsData/* reviewUdemy */.v$, reviewsData/* reviewEsl */.R$, reviewsData/* reviewBanijay */.Ho, reviewsData/* reviewSport1 */.cV] : _ref$data;
  var slides = react.useMemo(function () {
    return data.map(function (_ref2) {
      var logo = _ref2.logo,
          text = _ref2.text,
          author = _ref2.author;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* Logo */.T, {
          className: "mx-auto mb-5",
          height: typeof logo === 'string' ? 30 : logo.height,
          name: author.company,
          src: typeof logo === 'string' ? logo : logo.src,
          width: typeof logo === 'string' ? 100 : logo.width
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("blockquote", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
            className: ReviewsCarousel_cx('paragraph', 'mb-5'),
            size: "lg",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("q", {
              children: text.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                  children: [item, index !== text.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
                  })]
                }, typeof item === 'string' ? item : index);
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Author/* Author */.S, ReviewsCarousel_objectSpread({
            className: author.photo ? 'justify-content-center' : 'justify-content-center text-center',
            size: "md",
            theme: "round"
          }, author))]
        })]
      }, "".concat(author.name, "-").concat(author.role));
    });
  }, [data]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "mw-10 mx-auto",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Slider, {
      settings: {
        arrows: true,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0px',
        variableWidth: true
      },
      variant: "secondary",
      children: slides
    })
  });
};

/***/ }),

/***/ 72966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ho": function() { return /* binding */ reviewBanijay; },
  "R$": function() { return /* binding */ reviewEsl; },
  "ZH": function() { return /* binding */ reviewFactorio; },
  "ct": function() { return /* binding */ reviewGaijin; },
  "kX": function() { return /* binding */ reviewRakuten; },
  "cV": function() { return /* binding */ reviewSport1; },
  "hw": function() { return /* binding */ reviewStarz; },
  "v$": function() { return /* binding */ reviewUdemy; }
});

// UNUSED EXPORTS: reviewTedX

// EXTERNAL MODULE: ./src/components/Images/People/anton-yudintsev.png
var anton_yudintsev = __webpack_require__(23669);
var anton_yudintsev_default = /*#__PURE__*/__webpack_require__.n(anton_yudintsev);
// EXTERNAL MODULE: ./src/components/Images/People/joe-pietroni.jpg
var joe_pietroni = __webpack_require__(48252);
var joe_pietroni_default = /*#__PURE__*/__webpack_require__.n(joe_pietroni);
// EXTERNAL MODULE: ./src/components/Images/People/jordi-solsona.jpg
var jordi_solsona = __webpack_require__(37560);
var jordi_solsona_default = /*#__PURE__*/__webpack_require__.n(jordi_solsona);
// EXTERNAL MODULE: ./src/components/Images/People/madhu-venkatesh.jpg
var madhu_venkatesh = __webpack_require__(36673);
var madhu_venkatesh_default = /*#__PURE__*/__webpack_require__.n(madhu_venkatesh);
// EXTERNAL MODULE: ./src/components/Images/People/paolo-garri.jpg
var paolo_garri = __webpack_require__(77406);
var paolo_garri_default = /*#__PURE__*/__webpack_require__.n(paolo_garri);
// EXTERNAL MODULE: ./src/components/Images/People/robert-renc.jpg
var robert_renc = __webpack_require__(59474);
var robert_renc_default = /*#__PURE__*/__webpack_require__.n(robert_renc);
// EXTERNAL MODULE: ./src/components/Images/People/scott-daub.jpg
var scott_daub = __webpack_require__(975);
var scott_daub_default = /*#__PURE__*/__webpack_require__.n(scott_daub);
// EXTERNAL MODULE: ./src/components/Images/People/vinzenz-sinapius.jpg
var vinzenz_sinapius = __webpack_require__(50214);
var vinzenz_sinapius_default = /*#__PURE__*/__webpack_require__.n(vinzenz_sinapius);
// EXTERNAL MODULE: ./src/components/Images/Logos/Black/esl.svg
var esl = __webpack_require__(76644);
// EXTERNAL MODULE: ./src/components/Images/Logos/Black/gaijin.svg
var gaijin = __webpack_require__(10742);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/banijay.svg
var banijay = __webpack_require__(64533);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/factorio.png
var factorio = __webpack_require__(88610);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/rakuten.svg
var rakuten = __webpack_require__(24682);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/sport1.svg
var sport1 = __webpack_require__(37838);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/starz.svg
var starz = __webpack_require__(48550);
;// CONCATENATED MODULE: ./src/components/Images/Logos/Colored/tedXPragueDark.svg
var tedXPragueDark_namespaceObject = __webpack_require__.p + "static/media/tedXPragueDark.d1edcc13.svg";
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/udemy.svg
var udemy = __webpack_require__(29847);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ReviewsCarousel/reviewsData.tsx




















var reviewStarz = {
  logo: starz,
  text: [/*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: ["As a premium streaming platform, STARZ relies on CDN as a critical component of our success. CDN77 came to STARZ with very", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
      children: "competitive pricing to support our multi-CDN architecture"
    }), ". The onboarding process could not have been easier, and we were up and running in less than an hour. The support team", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
      children: "proactively analyzed our traffic and proposed some configuration changes to improve our cache hit ratio"
    }), ". With a few modifications, our service is consistently well above 95% cache hits."]
  }), "They are hands down the easiest CDN service I've worked with."],
  author: {
    name: 'Scott Daub',
    role: 'Principal Software Architect',
    company: 'STARZ',
    photo: (scott_daub_default())
  }
};
var reviewRakuten = {
  logo: rakuten,
  text: ['As a media business, maintaining a reliable multi-CDN stack for our live and on-demand video delivery is critical. After considering different alternatives, we chose CDN77 to be added to our CDN providers based on the performance metrics, capacity and quick individual approach.', 'The onboarding process with CDN77 was a breath of fresh air. Their personalized approach and level of customization were beyond expected. Their team consistently went the extra mile to support us through the transition, both technically and from a cost-cutting perspective.'],
  author: {
    name: 'Jordi Solsona',
    role: 'Playback Manager',
    company: 'Rakuten TV',
    photo: (jordi_solsona_default())
  }
};
var reviewUdemy = {
  logo: udemy,
  text: ['At the heart of Udemy, we always put our clients first. CDN77 has helped us offer the best possible user experience as their global CDN service speeds up the delivery of our video courses library.', 'It also keeps our entire delivery workflow cost-effective thanks to competitive pricing and robust private caching infrastructure that reduces our egress bandwidth volumes.'],
  author: {
    name: 'Madhu Venkatesh',
    role: 'Head of Learn and Media Engineering',
    company: 'Udemy',
    photo: (madhu_venkatesh_default())
  }
};
var reviewEsl = {
  logo: esl,
  text: ['Being at the forefront of the esports and video games industry means working with partners that share a similar mindset.', 'A lean, straight-forward, and performance-driven approach to CDN is both refreshing and clutch. We are happy to be working with CDN77 as one of our trusted CDN providers.'],
  author: {
    name: 'Ben Burns',
    role: 'VP of Technology',
    company: 'ESL Gaming'
  }
};
var reviewBanijay = {
  logo: banijay,
  text: ['Being a producer of highly successful works, such as Big Brother, Black Mirror and Peaky Blinders, we need to cooperate with reliable partners. CDN77 helps us deliver content through Roku. We treasure their high-quality service and exceptional support.'],
  author: {
    name: 'Joe Pietroni',
    role: 'Chief Technology Officer',
    company: 'Banijay',
    photo: (joe_pietroni_default())
  }
};
var reviewSport1 = {
  logo: sport1,
  text: ['CDN77 with the combination of their full Live streaming and VOD services enables a smooth user experience for our customers.', 'Their services encompass everything from RTMP ingest to secure delivery and "on-the-fly" encoding of our VOD content. We value their efficiency, reliability, and exceptional support.'],
  author: {
    name: 'Paolo Garri',
    role: 'Director of Technology',
    company: 'Sport1',
    photo: (paolo_garri_default())
  }
};
var reviewFactorio = {
  logo: {
    src: factorio,
    width: 180,
    height: 30
  },
  text: ['Just like Factorio’s ever-growing assembly lines, CDN77 is able to adapt and scale to meet our content distribution needs. They ensure fast and reliable access to our extensive database of community-generated content and updates for our 3.5 million players.', 'Their skilled and flexible team has exceeded our expectations by customizing their services to align with our unique requirements at no extra cost. With CDN77, our players enjoy a smooth gaming experience while we benefit from exceptional customer service.'],
  author: {
    name: 'Vinzenz Sinapius',
    role: 'Operations developer',
    company: 'Factorio',
    photo: (vinzenz_sinapius_default())
  }
};
var reviewGaijin = {
  logo: gaijin,
  text: ['CDN77 is incredibly easy to use and setup. Within minutes our customers were amazed at how quickly they could download and play their games. Also, they have quick and helpful customer service. I recommend CDN77 very much.'],
  author: {
    name: 'Anton Yudintsev',
    role: 'CEO',
    company: 'Gaijin Entertainment',
    photo: (anton_yudintsev_default())
  }
};
var reviewTedX = {
  logo: tedXPragueDark_namespaceObject,
  author: {
    name: 'Robert Renč',
    role: 'Media Partnerships Manager',
    company: 'TEDxPrague',
    photo: (robert_renc_default())
  },
  text: ['We pushed RTMP to CDN77’ streaming servers and their team took care of the rest. CDN77 managed the conversion to HLS and MPEG-DASH as well as transcoding, providing us with a ready-to-embed player. Superb support. Seamless delivery.']
};

/***/ }),

/***/ 43926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"Author_wrapper__21VZG","imageWrapper":"Author_imageWrapper__b6fBL","name":"Author_name__TobAk","square":"Author_square__3uOiV","avatar":"Author_avatar__vVSLk","round":"Author_round__asm0L","light":"Author_light__sJ8Oy","company":"Author_company___tDPt","dark":"Author_dark__XKMKT"};

/***/ }),

/***/ 36905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","icon":"Icon_icon__3jQrI","opacity-50":"Icon_opacity-50__CiBRs","opacity-60":"Icon_opacity-60__bt_jY","opacity-80":"Icon_opacity-80__LnAyL","opacity-100":"Icon_opacity-100__hIlYs","color-currentColor":"Icon_color-currentColor___y6C8","color-blue200":"Icon_color-blue200__XeDZ3","color-blue300":"Icon_color-blue300___2zM7","color-green400":"Icon_color-green400__Nf1Td","color-yellow200":"Icon_color-yellow200__v5cSt","color-gray500":"Icon_color-gray500__FxvF9","color-gray800":"Icon_color-gray800__TwMUp"};

/***/ }),

/***/ 8216:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"LogosRow_wrapper__WR_lP","noteWrapper":"LogosRow_noteWrapper__pgBXT","logoWrapper":"LogosRow_logoWrapper__C33vo","withNote":"LogosRow_withNote__4JNkb"};

/***/ }),

/***/ 97058:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","paragraph":"Paragraph_paragraph__RBIN1","isCentered":"Paragraph_isCentered__1qPdi","left":"Paragraph_left__OrqmC","center":"Paragraph_center__B6Qp0","right":"Paragraph_right__S2_ED","light":"Paragraph_light__mjqzY","opacity-60":"Paragraph_opacity-60__cM8oD","opacity-80":"Paragraph_opacity-80__m_wIn","opacity-100":"Paragraph_opacity-100__JFyb0","default":"Paragraph_default__yx1HZ","dark":"Paragraph_dark__JF_2J","inherit":"Paragraph_inherit__JRgKV","xs":"Paragraph_xs__zn_bN","sm":"Paragraph_sm__c0UHq","md":"Paragraph_md__OFeLp","lg":"Paragraph_lg__RAyzy","xl":"Paragraph_xl__9wzYU"};

/***/ }),

/***/ 6035:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","paragraph":"ReviewsCarousel_paragraph__Cd_5_"};

/***/ }),

/***/ 92830:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"Slider_wrapper__joNdI","sliderWrapper":"Slider_sliderWrapper__aepnn","list":"Slider_list__iSTbR","item":"Slider_item__8iOR9","label":"Slider_label__ieaG1","dotWrapper":"Slider_dotWrapper___IyI1","dot":"Slider_dot__oh9pq","arrow":"Slider_arrow__OQKQq","prev":"Slider_prev__ZwyIN","next":"Slider_next__gb0NK","icon":"Slider_icon__GcXL2","withShadow":"Slider_withShadow__f7T0G","secondary":"Slider_secondary__O1xLe","isActive":"Slider_isActive__1yPSg","withArrows":"Slider_withArrows__FRGJN"};

/***/ }),

/***/ 23669:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/anton-yudintsev-200.d26456e8.webp"+" 200w",
        images: [{path: "/_next/static/images/anton-yudintsev-200.d26456e8.webp",width: 200,height: 200}],
        src: "/_next/static/images/anton-yudintsev-200.d26456e8.webp",
        toString: function(){return "/_next/static/images/anton-yudintsev-200.d26456e8.webp"},
        
        width: 200,
        height: 200
      }

/***/ }),

/***/ 48252:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/joe-pietroni-200.35b5e676.webp"+" 200w",
        images: [{path: "/_next/static/images/joe-pietroni-200.35b5e676.webp",width: 200,height: 200}],
        src: "/_next/static/images/joe-pietroni-200.35b5e676.webp",
        toString: function(){return "/_next/static/images/joe-pietroni-200.35b5e676.webp"},
        
        width: 200,
        height: 200
      }

/***/ }),

/***/ 37560:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/jordi-solsona-183.6d915d86.webp"+" 183w",
        images: [{path: "/_next/static/images/jordi-solsona-183.6d915d86.webp",width: 183,height: 181}],
        src: "/_next/static/images/jordi-solsona-183.6d915d86.webp",
        toString: function(){return "/_next/static/images/jordi-solsona-183.6d915d86.webp"},
        
        width: 183,
        height: 181
      }

/***/ }),

/***/ 36673:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/madhu-venkatesh-200.444b0de5.webp"+" 200w",
        images: [{path: "/_next/static/images/madhu-venkatesh-200.444b0de5.webp",width: 200,height: 200}],
        src: "/_next/static/images/madhu-venkatesh-200.444b0de5.webp",
        toString: function(){return "/_next/static/images/madhu-venkatesh-200.444b0de5.webp"},
        
        width: 200,
        height: 200
      }

/***/ }),

/***/ 77406:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/paolo-garri-240.f5bd2ec0.webp"+" 240w",
        images: [{path: "/_next/static/images/paolo-garri-240.f5bd2ec0.webp",width: 240,height: 240}],
        src: "/_next/static/images/paolo-garri-240.f5bd2ec0.webp",
        toString: function(){return "/_next/static/images/paolo-garri-240.f5bd2ec0.webp"},
        
        width: 240,
        height: 240
      }

/***/ }),

/***/ 59474:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/robert-renc-320.bdd4de28.webp"+" 320w",
        images: [{path: "/_next/static/images/robert-renc-320.bdd4de28.webp",width: 320,height: 320}],
        src: "/_next/static/images/robert-renc-320.bdd4de28.webp",
        toString: function(){return "/_next/static/images/robert-renc-320.bdd4de28.webp"},
        
        width: 320,
        height: 320
      }

/***/ }),

/***/ 975:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/scott-daub-442.d9596f3e.webp"+" 442w",
        images: [{path: "/_next/static/images/scott-daub-442.d9596f3e.webp",width: 442,height: 442}],
        src: "/_next/static/images/scott-daub-442.d9596f3e.webp",
        toString: function(){return "/_next/static/images/scott-daub-442.d9596f3e.webp"},
        
        width: 442,
        height: 442
      }

/***/ }),

/***/ 50214:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/vinzenz-sinapius-120.ff0f1d83.webp"+" 120w",
        images: [{path: "/_next/static/images/vinzenz-sinapius-120.ff0f1d83.webp",width: 120,height: 120}],
        src: "/_next/static/images/vinzenz-sinapius-120.ff0f1d83.webp",
        toString: function(){return "/_next/static/images/vinzenz-sinapius-120.ff0f1d83.webp"},
        
        width: 120,
        height: 120
      }

/***/ }),

/***/ 76644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/esl.aa659007.svg";

/***/ }),

/***/ 10742:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/gaijin.6ced0e1f.svg";

/***/ }),

/***/ 95145:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/avast.893f8a27.svg";

/***/ }),

/***/ 64533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/banijay.33f0333c.svg";

/***/ }),

/***/ 88610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/factorio.49d8eaad.png";

/***/ }),

/***/ 24682:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/rakuten.ba3de73a.svg";

/***/ }),

/***/ 37838:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/sport1.6f721a0b.svg";

/***/ }),

/***/ 48550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/starz.8507d45d.svg";

/***/ }),

/***/ 29847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/udemy.ae0b8c1b.svg";

/***/ })

}]);